import React from 'react'
import { AccordionHeader, BasicAccordion } from '../../Components/Layout/Accordion'
import { DraftTradeItems } from './DraftTradeItems'
import { DraftTradeCon } from './styles'

export const DraftTrades: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <DraftTradeCon>
      <BasicAccordion
        defaultPanel={0}
        accordionItems={[
          {
            headerComponent: (
              <AccordionHeader
                label={`Draft Picks acquired via trade`}
                subText={``}
                size="medium"
              />
            ),
            summaryComponent: <DraftTradeItems />,
          },
        ]}
      />
    </DraftTradeCon>
  )
}
